import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesSharing } from "../../constants";
import { UpdateSharingScheduleBody } from "./updateSharingSchedule.types";

export const requestUpdateSharingSchedule = async ({
  id,
  ...body
}: UpdateSharingScheduleBody): Promise<void> => {
  return await instance.patch(
    buildUrl(ApiRoutesSharing.SharingSchedules, id),
    body
  );
};
